import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Switch, useHistory } from 'react-router-dom'
import { Mask, DotLoading, TabBar } from 'antd-mobile';
import { Application, Bootstrap } from "@yulintu/freesia-bootstrap";

import "../../../css/overwrites.less";
import "../../../css/framework.less";
import "./index.less";

const ClassicLayout = function (props) {

    const context = useContext(Application.Context);

    const history = useHistory();

    const [busy, setBusy] = useState(true);
    const [selectedKey, setSelectedKey] = useState();
    const [manifests, setManifests] = useState([]);

    useEffect(() => {
        setBusy(true);
        Bootstrap.resolve(props.metadata.children, props.metadata).then(data => {
            setManifests(data);
        }).finally(() => {
            setBusy(false);
        });
    }, [props.metadata]);

    useEffect(() => {

        if (manifests && manifests.length)
            Bootstrap.resetPermission(manifests, { userInfo: context.global.userInfo });

    }, [props.metadata, manifests, context.global.userInfo]);

    const setGlobal = context.setGlobal;
    const onLoginSuccess = useCallback((userInfo) => {
        setGlobal({ userInfo });
    }, [setGlobal]);

    let matchItem = Bootstrap.match(manifests, window.location.pathname);
    if (!matchItem)
        matchItem = Bootstrap.findDefault(manifests);

    const tabbarVisible = window.location.pathname.endsWith(matchItem?.routePath);
    console.log(tabbarVisible, matchItem?.routePath, window.location.pathname);

    return busy ? <>
        <Mask visible={true}>
            <DotLoading />
        </Mask>
    </> : <>
        <div className="freesia-design-mobile classic-layout">
            <div className="content">
                <Switch>
                    {
                        Bootstrap.routes(context.factory, manifests, props.metadata, {
                            config: context.config,
                            onLoginSuccess: onLoginSuccess
                        })
                    }
                </Switch>
            </div>
            <div className="tabbar">
                <TabBar activeKey={selectedKey || matchItem?.key} onChange={(e) => {
                    setSelectedKey(e);
                    history.replace(e);
                }}>
                    {
                        manifests.map(c => (
                            c.visible !== false && <TabBar.Item key={c.key} title={c.alias} badge={(c.props?.badge?.template && context.factory.load(c.props?.badge?.template, { ...c.props?.badge?.props, metadata: c.props?.badge })) || undefined} icon={value => ((value && (c.props?.icon?.template || c.props?.iconSelected?.template)) && context.factory.load(c.props?.iconSelected?.template || c.props?.icon?.template)) || ((!value && c.props?.icon?.template) && context.factory.load(c.props?.icon?.template))} />
                        )).filter(c => c)
                    }
                </TabBar>
            </div>
        </div>
    </>
}

export default ClassicLayout;